export enum CmsCollectionSchemaDataCodeEditorTypeEnum {
  XML = 1,
  JSON = 2,
}
